/**
 * Auto-matches file column headers to target field names using case-insensitive comparison.
 * Returns a mapping of target field name -> matched header name.
 *
 * Only exact case-insensitive matches are produced. Each header can only be matched once.
 */
export function autoMatchColumns(
  headers: string[],
  targetFields: string[]
): Record<string, string> {
  const result: Record<string, string> = {};
  const usedHeaders = new Set<string>();

  for (const field of targetFields) {
    const fieldLower = field.toLowerCase();
    for (const header of headers) {
      if (usedHeaders.has(header)) continue;
      if (header.toLowerCase() === fieldLower) {
        result[field] = header;
        usedHeaders.add(header);
        break;
      }
    }
  }

  return result;
}
